import React from 'react';

import { AsyncSelectField, MCButton, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import { lang, remCss } from 'src/helpers';

import model from './model';
import ShortInfo from 'src/components/user/ShortInfo';
import LANG_CONST from 'src/helpers/lang/const';
import HospitalSelect from 'components/complex/HospitalSelect';

const chatTicketDurationOptions = [
  { value: 1, label: `1 ${lang.t('Days')}` },
  { value: 2, label: `2 ${lang.t('Days')}` },
  { value: 3, label: `3 ${lang.t('Days')}` },
  { value: 4, label: `4 ${lang.t('Days')}` },
  { value: 5, label: `5 ${lang.t('Days')}` },
  { value: 7, label: `1 ${lang.t('Week')}` },
  { value: 14, label: `2 ${lang.t('Weeks')}` },
  { value: 21, label: `3 ${lang.t('Weeks')}` },
  { value: 30, label: `4 ${lang.t('Weeks')}` }
];

export default class Add extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { ...model.chargeObject() };
  }

  componentDidMount() {
    model.subscribe(this.subscription);
    this.resetCharge();
  }

  resetCharge = () => {
    model.resetApiState('add');
    this.setState({
      ...model.chargeObject()
    });
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  submit = (e) => {
    e.preventDefault();
    const { hide } = this.props;
    model.addCharge(
      {
        id: this.state.id,
        first: this.state.first,
        followup: this.state.followup,
        chatTicket: this.state.chatTicket
      },
      (error) => {
        if (!error) hide();
      }
    );
  };
  render() {
    const { closeBtn } = this.props;
    const { user } = model.state;
    const { invalid, loading, ...createState } = model.getApiState('add');
    let followUpDuration = model.input('followupDuration') || 30;

    if (invalid.id) invalid.id = !user?.isDoctor ? 'Doctor is required.' : 'Hospital is required.';

    return (
      <div className={'mc-popup-contain'} style={{ width: remCss(600) }}>
        <div className='mc-modal-header'>
          <div className='mc-title'>{lang.t('Add new charge')}</div>
          {closeBtn}
        </div>
        <div className='mc-modal-body mc-flex-15-col'>
          <div className={'mc-flex-20-col'}>
            {!user?.isDoctor && (
              <AsyncSelectField
                template={6}
                isClearable={false}
                defaultValue={true}
                placeholder={'Doctor'}
                label={'Doctor'}
                apiConfig={{
                  url: 'clinic/doctor/list',
                  labelFn: (item) => <ShortInfo small user={item} />
                }}
                name={'id'}
                invalid={invalid}
                value={this.state.id}
                onChange={(n, v) => {
                  model.resetApiState('add');
                  this.setState({ id: v });
                }}
              />
            )}
            {user?.isDoctor && (
              <HospitalSelect
                template={6}
                isClearable={false}
                defaultValue={true}
                name={'id'}
                invalid={invalid}
                value={this.state.id}
                onChange={(n, v) => {
                  model.resetApiState('add');
                  this.setState({ id: v });
                }}
              />
            )}
            <div className={'mc-value-620'}>First consultation</div>
            <div className={'mc-flex-20'}>
              {[
                { n: 'virtual', l: 'Virtual' },
                { n: 'office', l: 'Office' }
                // { n: 'chatTicket', l: 'Chat Ticket' }
              ].map((option) => (
                <div className={'mc-grow'} key={'first_' + option.n}>
                  <TextField
                    template={3}
                    type={'money'}
                    placeholder={'Not Set'}
                    label={option.l}
                    name={option.n}
                    value={this.state.first[option.n]}
                    onChange={(name, value) => {
                      model.resetApiState('add');
                      if (value < 0 || value > 9999 || parseInt(value) !== value) return;
                      this.setState({ first: { ...this.state.first, [name]: value } });
                    }}
                    invalid={invalid[option.n]}
                    disabled={loading}
                  />
                </div>
              ))}
            </div>
            <div className={'mc-value-620'}>{`Follow up - resets in ${followUpDuration} days`}</div>
            <div className={'mc-flex-20'}>
              {[
                { n: 'virtual', l: 'Virtual' },
                { n: 'office', l: 'Office' }
                // { n: 'chatTicket', l: 'Chat Ticket' }
              ].map((option) => (
                <div className={'mc-grow'} key={'followup_' + option.n}>
                  <TextField
                    template={3}
                    type={'money'}
                    placeholder={'Not Set'}
                    label={option.l}
                    name={option.n}
                    value={this.state.followup[option.n]}
                    onChange={(name, value) => {
                      model.resetApiState('add');
                      if (value < 0 || value > 9999 || parseInt(value) !== value) return;
                      this.setState({ followup: { ...this.state.followup, [name]: value } });
                    }}
                    invalid={invalid[option.n]}
                    disabled={loading}
                  />
                </div>
              ))}
            </div>
            <div className={'mc-value-620'}>{lang.t(`Chat ticket`)}</div>
            <div className={'mc-flex-20'}>
              <div className={'mc-grow'}>
                <TextField
                  template={3}
                  type={'money'}
                  placeholder={'Not Set'}
                  label={'Price'}
                  name={'price'}
                  value={this.state.chatTicket['price'] || ''}
                  onChange={(name, value) => {
                    model.resetApiState('add');
                    if (value < 0 || value > 9999 || parseInt(value) !== value) return;
                    this.setState({ chatTicket: { ...this.state.chatTicket, [name]: value } });
                  }}
                  invalid={invalid['price']}
                  disabled={loading}
                />
              </div>
              <div className={'mc-grow'}>
                <TextField
                  template={3}
                  type='select'
                  placeholder={'Not Set'}
                  label={'Duration'}
                  name={'duration'}
                  value={this.state.chatTicket['duration'] || ''}
                  onChange={(name, value) => {
                    model.resetApiState('add');
                    this.setState({ chatTicket: { ...this.state.chatTicket, [name]: value } });
                  }}
                  invalid={invalid['duration']}
                  disabled={loading}
                  inputProps={{
                    minWidth: remCss(150),
                    options: chatTicketDurationOptions
                  }}
                />
              </div>
            </div>
            <div className={'mc-flex-20'}>
              <div className={'mc-grow'}>
                <TextField
                  type='number'
                  template={3}
                  placeholder={'Not Set'}
                  label={LANG_CONST.no_of_message}
                  name={'messagesCount'}
                  value={this.state.chatTicket['messagesCount'] || ''}
                  onChange={(name, value) => {
                    model.resetApiState('add');

                    if (value < 0 || value > 9999 || parseInt(value) !== value) return;
                    this.setState({ chatTicket: { ...this.state.chatTicket, [name]: value } });
                  }}
                  invalid={invalid['messagesCount']}
                  disabled={loading}
                />
              </div>
              <div className={'mc-grow'}>
                <TextField
                  template={3}
                  type={'money'}
                  placeholder={'Not Set'}
                  label={'Extra message'}
                  name={'extraMessage'}
                  value={this.state.chatTicket['extraMessage'] || ''}
                  onChange={(name, value) => {
                    model.resetApiState('add');
                    if (value < 0 || value > 9999 || parseInt(value) !== value) return;
                    this.setState({ chatTicket: { ...this.state.chatTicket, [name]: value } });
                  }}
                  invalid={invalid['extraMessage']}
                  disabled={loading}
                />
              </div>
            </div>
          </div>
          {invalid.charge?.required_all && (
            <p className='mc-error'>{invalid.charge.required_all}</p>
          )}
          {createState.error && <p className='mc-error'>{createState.errorMessage}</p>}
        </div>
        <div className='mc-modal-footer mc-flex'>
          <MCButton
            medium
            radius
            light
            primary
            className='mc-grow'
            type={'button'}
            onClick={this.props.hide}
          >
            {lang.t('Cancel')}
          </MCButton>
          <MCButton
            medium
            radius
            dark
            primary
            className='mc-grow'
            type={'button'}
            onClick={this.submit}
          >
            {lang.t(loading ? 'Adding...' : 'Add Charge')}
          </MCButton>
        </div>
      </div>
    );
  }
}
